<template>
  <div class="button-container p5 pointer" data-testid="addToCart" @click="preAddToCart(product)" :disabled="isProductDisabled">
    <span :class="[qtyInCart ? 'non-empty' : 'empty']" >
      <i class="material-icons" style="width: 24px; height: 24px; overflow: hidden;">shopping_cart</i>
    </span>
    <svg class="spinner" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
    </svg>
  </div>
</template>

<script>
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages'
import focusClean from 'theme/components/theme/directives/focusClean'
import { AddToCart } from '@vue-storefront/core/modules/cart/components/AddToCart'

export default {
  mixins: [AddToCart],
  directives: { focusClean },
  methods: {
    onAfterRemovedVariant () {
      this.$forceUpdate()
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    },
    preAddToCart (product) {
      if (!this.needToDisplayConfigurator) {
        this.$bus.$emit('modal-hide', `modal-custom-options-${this.product.sku}-${this.categoryId}`)
        this.addToCart(product);
        this.$forceUpdate();
      } else {
        this.$bus.$emit('modal-show', `modal-search-custom-options-${this.product.sku}`)
      }
    }
  },
  computed: {
    isProductDisabled () {
      return this.disabled || formatProductMessages(this.product.errors) !== '' || this.isAddingToCart
    },
    qtyInCart () {
      if (this.cartItem) {
        return this.cartItem.qty
      }
    },
    needToDisplayConfigurator () {
      if (!this.product.custom_options || this.product.custom_options.length === 0 || this.product.custom_options.filter(option => option.is_active === 1).length == 0) {
        return false
      }
      if (this.product.custom_options.length > 1) {
        return true
      }
      return (!this.product.custom_options[0].is_require && this.product.custom_options[0].values.length > 1)
    },
  },
  beforeMount () {
    this.$bus.$on('product-after-removevariant', this.onAfterRemovedVariant)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-removevariant')
  }
}
</script>
<style lang="scss" scoped>
  i{
    margin:0;
  }
  .button-container {
    border: 2px solid rgb(67, 176, 42);
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgb(67, 176, 42);
    opacity: 1;
    min-width: 20px;
    height: 20px;
    color: #fff;
    justify-content: center;

    &:hover {
      background-color: #fff;
      color: rgb(67, 176, 42);
    }

    i.material-icons {
      vertical-align: bottom;
      font-size: 20px;
    }
  }

  .spinner {
    display: none;
    animation: rotate 2s linear infinite;
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -15px 0 0 -15px;
    width: 30px;
    height: 30px;

    & .path {
      stroke: rgb(67, 176, 42);;
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }

  .disabled {
    div.spinner {
      display: block;
    }

    img {
      display: none;
    }
  }

  @keyframes scale {
    0% {
      transform: scaleY(0);
    }
    50% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(0);
    }
  }

</style>
<style>
  .product-listing .product {
    position: relative;
  }
</style>
